<template>
  <div>
    <div class="overflow-auto">
      <table id="table-details">
        <thead>
          <tr>
            <th>{{ $t('scoreAssessment.componentSub') }}</th>
            <th>
              {{ $t('scoreAssessment.maxScore') }}
              <span class="text-red">*</span>
            </th>
            <th>{{ $t('scoreAssessment.maxScoreSemester') }}</th>
            <th>{{ $t('scoreAssessment.maxScoreScience') }}</th>
            <th>{{ $t('scoreAssessment.maxScoreSemesterScience') }}</th>
            <th>{{ $t('scoreAssessment.percentage') }}</th>
            <th>{{ $t('scoreAssessment.multiplier') }}</th>
            <th>
              <p v-tooltip="$t('scoreAssessment.thresholdTooltip')">
                {{ $t('scoreAssessment.threshold') }}
                <span>
                  <i class="fas fa-question-circle"></i>
                </span>
              </p>
            </th>
            <th>
              <p v-tooltip="$t('scoreAssessment.scoringThresholdTooltip')">
                {{ $t('scoreAssessment.scoringThreshold') }}
                <span>
                  <i class="fas fa-question-circle"></i>
                </span>
              </p>
            </th>
            <th>{{ $t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(components, index) in model">
            <tr :key="index">
              <td valign="middle">
                <span class="badge badge-primary">{{
                  getComponentName(components.sc_subject_id)
                }}</span>
              </td>
              <td>
                <input
                  v-model.number="components.actual_score"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="components.actual_score_semester"
                  :disabled="!components.enable_semester"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="components.actual_score_sciense"
                  :disabled="!components.enable_sciense"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="components.actual_score_sciense_semester"
                  :disabled="
                    !(components.enable_sciense && components.enable_semester)
                  "
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="components.percentage"
                  :disabled="!components.is_percentage"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="components.sc_multiplier"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td class="text-center">
                <ts-checkbox
                  v-model="components.enable_semester_scoring_threshold_option"
                  @change="thresholdChange(components)"
                ></ts-checkbox>
              </td>
              <td>
                <input
                  :disabled="
                    !components.enable_semester_scoring_threshold_option
                  "
                  v-model.number="components.semester_scoring_threshold"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td class="text-red text-center">
                <a
                  href="#"
                  @click.prevent="removeComponent(index)"
                  v-if="components.sc_setup_detail_id == 0"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
                <span v-else class="text-info">
                  <i class="fas fa-hdd"></i>
                </span>
              </td>
            </tr>
            <tr
              v-for="(item,
              subIndex) in components.score_component_detail_item_list"
            >
              <td class="text-right">
                {{
                  getSubComponentName(
                    components.sc_subject_id,
                    item.sc_item_subject_id
                  )
                }}
              </td>
              <td>
                <input
                  v-model.number="item.actual_score"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="item.actual_score_semester"
                  :disabled="!item.enable_semester"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="item.actual_score_sciense"
                  :disabled="!item.enable_sciense"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="item.actual_score_sciense_semester"
                  :disabled="!(item.enable_sciense && item.enable_semester)"
                  type="number"
                  class="bb form-control"
                />
              </td>
              <td>
                <input
                  v-model.number="item.percentage"
                  :disabled="!item.is_percentage"
                  type="number"
                  class="bb form-control"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <br />
      <ts-button
        color="primary"
        class="ts-rounded-full ts-h-10 ts-w-10 flex ts-items-center justify-center"
        v-if="availableItem"
        @click.prevent="() => (show_form_component_list_add = true)"
      >
        <i class="fa fa-plus"></i>
      </ts-button>
      <a-modal
        v-model="show_form_component_list_add"
        :zIndex="1020"
        :title="$t('scoreAssessment.component')"
        :maskClosable="false"
        :footer="null"
        @cancle="() => (show_form_component_list_add = false)"
        width="20%"
      >
        <show-component-list :list="componentListFilter" @add="addedItem" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import ShowComponentList from './component-list'

export default {
  name: 'componentTableList',
  props: ['componentList', 'value', 'params'],
  components: {
    ShowComponentList
  },
  data() {
    return {
      show_form_component_list_add: false,
      model: [],
      component: {
        sc_setup_detail_id: 0,
        sc_setup_id: null,
        program_structure_id: null,
        sc_subject_id: null,
        actual_score: 0,
        enable_semester: false,
        actual_score_semester: 0,
        enable_sciense: false,
        actual_score_sciense: 0,
        actual_score_sciense_semester: 0,
        sc_ass_cat_id: null,
        remarks: null,
        is_percentage: false,
        percentage: 0,
        sc_multiplier: null,
        enable_semester_scoring_threshold_option: false,
        semester_scoring_threshold: 0,
        score_component_detail_item_list: [
          {
            sc_setup_detail_item_id: 0,
            sc_item_subject_id: null,
            actual_score: 0,
            enable_semester: false,
            actual_score_semester: 0,
            enable_sciense: false,
            actual_score_sciense: 0,
            actual_score_sciense_semester: 0,
            remarks: null,
            is_percentage: false,
            percentage: 0
          }
        ]
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    availableItem() {
      return (_.orderBy(this.componentList, ['display_order']).filter(
          c => !_.includes(this.model.map(el => el.sc_subject_id), c.id)
        ).length > 0
      )
    },
    componentListFilter() {
      return _.orderBy(this.componentList, ['display_order']).filter(
        c => !_.includes(this.model.map(el => el.sc_subject_id), c.id)
      )
    }
  },
  methods: {
    addedItem(item) {
      this.model.push({
        sc_setup_detail_id: 0,
        sc_setup_id: this.params.sc_setup_id,
        program_structure_id: this.params.program_structure_id,
        sc_subject_id: item.id,
        actual_score: 0,
        enable_semester: false,
        actual_score_semester: 0,
        enable_sciense: false,
        actual_score_sciense: 0,
        actual_score_sciense_semester: 0,
        sc_ass_cat_id: null,
        remarks: null,
        is_percentage: false,
        percentage: 0,
        sc_multiplier: 1,
        enable_semester_scoring_threshold_option: false,
        semester_scoring_threshold: 0,
        score_component_detail_item_list: item.items.map(el => ({
          sc_setup_detail_item_id: 0,
          sc_item_subject_id: el.id,
          actual_score: 0,
          enable_semester: false,
          actual_score_semester: 0,
          enable_sciense: false,
          actual_score_sciense: 0,
          actual_score_sciense_semester: 0,
          remarks: null,
          is_percentage: false,
          percentage: 0
        }))
      })
    },
    getComponentName(sc_subject_id) {
      return this.componentList
        .filter(c => c.id == sc_subject_id)
        .map(el => el.name)
        .reduce((init, item) => (init = item), null)
    },
    getSubComponentName(sc_subject_id, sc_item_subject_id) {
      return this.componentList
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(subitem => subitem.id == sc_item_subject_id)
        )
        .reduce((init, item) => (init = item.name), null)
    },
    thresholdChange(row) {
      if (!row.enable_semester_scoring_threshold_option) {
        row.semester_scoring_threshold = 0
      }
    },
    removeComponent(index) {
      this.model.splice(index, 1)
    }
  },
  watch: {
    value: {
      handler(value) {
        this.model = value
      },
      deep: true
    }
  }
}
</script>
<style lang="css" scoped>
#table-details {
  width: 100%;
}
#table-details > thead > tr > th {
  padding: 5px 4px;
  background: #f2f3f4;
}
#table-details > tbody > tr > td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}
.bb {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
